import { format } from 'date-fns';
import zonedDate from './zoned-date';

export default function (date) {
    date = date instanceof Date ? date : zonedDate(date);

    return format(date, date.getMinutes() ? 'h:mmaa' : 'haa');
}
